<div class="payout" *ngIf="payout">
  <div class="header">
    <h1>Policy Benefit Summary - Example</h1>
  </div>
  <div class="block">
    <div class="cubes ion-margin-vertical">
      <div class="cube1">Sum Assured</div>
      <div class="cube2">{{results.sumAssured | appcurrency}}</div>
    </div>
    <div class="cubes ion-margin-vertical">
      <div class="cube1">Benefit Payments</div>
      <div class="cube2"></div>
    </div>

    <div class="cubes" *ngFor="let p of payout; let i = index" >
      <div class="index">{{i+1}}.</div><div class="cube1"> {{p.condition}}</div>
      <div class="cube2">{{p.payout | appcurrency}}</div>
    </div>
    <div class="divider"></div>
    <div class="totals">
      <div class="cube1">Total Benefits Paid</div>
      <div class="cube2">{{totalBenefit | appcurrency}}</div>
    </div>
    <div class="totals">
      <div class="cube1">% of Sum Assured</div>
      <div class="cube2">{{totalBenefit / results.sumAssured | percent}}</div>
    </div>
  </div>
</div>
